import { createContext } from "react";

const LegalVacationDaysContext = createContext();

export default LegalVacationDaysContext;
